import { Typography } from 'mobily-ui-library/lib'
import { useTranslation } from 'react-i18next';
import './StoreMapPopup.scss';
import SelfServiceKiosk from '../../../assets/SelfServiceKiosk.svg';
import WheelChair from '../../../assets/WheelChair.svg'

const StoreMapPopup = ({ places, status, time, type, ssk, disabilityFriendly, id, rtl, mode }: any) => { 
    const { t } = useTranslation();

    return (
        <div className={rtl ? 'MapPopup__container Map_arabic' : 'MapPopup__container'}>
            {type === 'currentLocation' ? (
                <Typography className='MPU__text'><span>{t('current_location')}</span></Typography>
            ) : (
                <div>
                    <Typography className='MPU__text'>{time} <span>{status}</span></Typography>
                </div>
            )}
            <Typography className='MPU__place'>{places}</Typography>
            {type === 'Store' && (
                <div className={rtl ? 'MapPopup_service_container Map_arabic' : 'MapPopup_service_container'}>

                    {ssk === 'True' && <Typography className='MPU__text'>
                        <img src={SelfServiceKiosk} alt='selfservicekiosk' /> 
                        <span>
                            {t("self_service_kiosk")}
                        </span>
                    </Typography>}

                    {disabilityFriendly === 'True' && <Typography className='MPU__text'>
                        <img src={WheelChair} alt='wheelchair' /> 
                        <span>
                            {t("disability_friendly")}
                        </span>
                    </Typography>}

                </div>
            )}

            {type === 'Store' && (
                <button
                    id={`mpuButton${id}`}
                    className='MPU__button'
                    style={{ display: mode ? 'none' : "block" }}
                >
                    {t("get_directions")}
                </button>
            )}
        </div>
    )
}


export default StoreMapPopup;